<template>
  <textarea></textarea>
</template>
<script>
require('summernote')
export default {
  name: 'summernote',
  model: {
    prop: 'text',
    event: 'change'
  },
  props: {
    text: {
      required: true
    },
    height: {
      type: String,
      default: '150'
    }
  },
  mounted () {
    let config = {
      height: this.height
    }
    let vm = this
    config.callbacks = {
      onInit () {
        $(vm.$el).summernote('code', vm.text)
      },
      onChange () {
        vm.$emit('change', $(vm.$el).summernote('code'))
      }
    }
    $(this.$el).summernote(config)
  },
  beforeDestroy () {
    $(this.$el).summernote('destroy')
  }
}
</script>
<style>
@import 'summernote/dist/summernote.css';
</style>



// WEBPACK FOOTER //
// src/components/Addons/Summernote.vue